/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TileRateProvision = {
    type?: TileRateProvision.type;
    name?: string;
};
export namespace TileRateProvision {
    export enum type {
        UNKNOWN = 'Unknown',
        NO_MEAL = 'NoMeal',
        BREAKFAST = 'Breakfast',
        HALF_BOARD = 'HalfBoard',
        FULL_BOARD = 'FullBoard',
        ALL_INCLUSIVE = 'AllInclusive',
        SOFT_ALL_INCLUSIVE = 'SoftAllInclusive',
        LUNCH = 'Lunch',
        DINNER = 'Dinner',
    }
}
